import algoliasearch from 'algoliasearch/lite';

function getClient() {

  const client = algoliasearch(
    process.env.NEXT_PUBLIC_ALGOLIA_APP_ID, 
    process.env.NEXT_PUBLIC_ALGOLIA_CLIENT_KEY
  );
  return client;
}

export default getClient();
